// extracted by mini-css-extract-plugin
export default {"filterWrapper":"vacancyFilter_filterWrapper__ndq7y"};